// Actions
export const COMPONENT_MOUNT_ACTIONS_TYPES = {
    isMounted: () => 'IS_MOUNTED',
};
  